import styled from 'styled-components';

export const StyledInlineDiv = styled.div`
  .ant-row {
    display: inline-block;
  }
  .form-inline {
    display: inline-block;
  }
`;
export const StyledHelpLinkDiv = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
`;
